import { FigureAxisSettingsDto, isFigureAxisSettingsDto } from "./FigureAxisSettingsDto";
import { FigureLegendSettingsDto, isFigureLegendSettingsDto } from "./FigureLegendSettingsDto";
import {
  FigureRegressionLineSettingsDto,
  isFigureRegressionLineSettingsDto,
} from "./FigureRegressionLineSettingsDto";
import { FigureTypeSettingsDto, isFigureTypeSettingsDto } from "./FigureTypeSettingsDto";
import { FigureVarSettingsDto, isFigureVarSettingsDto } from "./FigureVarSettingsDto";

/**
 * Defines the complete settings for a figure, including type configurations, axis, legend, and line settings.
 */
export interface FigureSettingsDto {
  figureTypeSettings: FigureTypeSettingsDto[];
  figureProperties: FigureVarSettingsDto[];
  figureAxisSettings: FigureAxisSettingsDto[];
  figureLegendSettings: FigureLegendSettingsDto[];
  figureReferenceLinesSettings: FigureVarSettingsDto[];
  figureRegressionLineSettings: FigureRegressionLineSettingsDto[];
}

/**
 * Type guard to check if an object is a FigureSettingsDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the full figure settings shape.
 */
export const isFigureSettingsDto = (obj: unknown): obj is FigureSettingsDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureSettingsDto;
  if (!Array.isArray(chkObj.figureTypeSettings)) {
    return false;
  }
  if (chkObj.figureTypeSettings.some((option) => !isFigureTypeSettingsDto(option))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureProperties)) {
    return false;
  }
  if (chkObj.figureProperties.some((setting) => !isFigureVarSettingsDto(setting))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureAxisSettings)) {
    return false;
  }
  if (chkObj.figureAxisSettings.some((setting) => !isFigureAxisSettingsDto(setting))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureLegendSettings)) {
    return false;
  }
  if (chkObj.figureLegendSettings.some((setting) => !isFigureLegendSettingsDto(setting))) {
    return false;
  }
  if (!Array.isArray(chkObj.figureRegressionLineSettings)) {
    return false;
  }
  if (
    chkObj.figureRegressionLineSettings.some(
      (setting) => !isFigureRegressionLineSettingsDto(setting),
    )
  ) {
    return false;
  }
  if (!Array.isArray(chkObj.figureReferenceLinesSettings)) {
    return false;
  }
  if (chkObj.figureReferenceLinesSettings.some((setting) => !isFigureVarSettingsDto(setting))) {
    return false;
  }
  return true;
};
